import React, { useEffect, useRef, useState } from 'react';
import { Button, ListGroup, Modal } from 'react-bootstrap';
import Layout from "../../components/Layout";
import { EN } from '../../Languages/EN';
import { DE } from '../../Languages/DE';
import LanguageContext from '../../helper/LanguageContext';
import { Link, withRouter } from 'react-router-dom';
import { callAPI } from "../../helper/apiUtils";
import { BASE_URL } from "../../helper/constants";
import ShareMapDialog from "../../components/ShareMapDialog";
import { Positions } from "../../Languages/vars/Positions";
import { $crud } from "../../helper/CrudFactory";
import Carousel from "react-multi-carousel";
import { $user } from "../../helper/UserFactory";
import { ForienArticle } from '../Feeds/ForienArticle';
import { convertBranchRole, convertPosition } from '../../helper/convertor';
import { ARTICLE, RIGHT_TOP, SET_OPEN_SIDE_BAR } from '../../store';
import { useDispatch, useSelector } from 'react-redux';
import { BsChevronLeft, BsFillEyeFill, BsFillPlusCircleFill, BsSearch } from "react-icons/bs";
import FeedViewDialog from '../Feeds/Dialogs/FeedViewDialog';
import { Skeleton } from '@material-ui/lab';
import "./ForeignCompanyDetails.css";

const user = $user.get();

function ForeignCompanyDetails(props) {
    const { isGerm, strings, language } = React.useContext(LanguageContext);
    const articleContentLang = (language || (isGerm ? 'de' : 'en') || 'de')
        .toString()
        .split(/[-_]/)[0]
        .toLowerCase();
    const CarouselEl = useRef()
    const [slideNo, setSlideNo] = useState(0)
    const [company, setCompany] = useState({})
    let [companyBranch, setCompanyBranch] = useState()
    const [show, setShow] = useState(false)
    const [employeePosition, setEmployeePosition] = useState();
    const [showPositionDialog, setPositionDialog] = useState(false);
    const [externalArticles, setExternalArticles] = useState([]);
    const handleClose = () => setShow(false);
    const hidePositionDialog = () => setPositionDialog(false);
    const [services, setServices] = useState([]);
    const [closeHover, setCloseHover] = useState(false);
    const [backBtnHovered, setBackBtnHovered] = useState(false);
    const [companyLoading, setCompanyLoading] = useState(true);
    const [articlesLoading, setArticlesLoading] = useState(false);
    
    // Get Redux article state for FeedViewDialog
    const article = useSelector(state => state.article);
    const articlesList = useSelector(state => state.articlesList);
    const currentArticleIndex = useSelector(state => state.currentArticleIndex);
    
    // Function to view article with navigation context
    const viewArticleWithContext = (articleToView, index) => {
        const list = externalArticles || [];
        // Find the actual index by ID to ensure correctness
        let actualIndex = list.findIndex(a => a && a.id === articleToView.id);
        if (actualIndex === -1) {
            actualIndex = index; // Fallback to the passed index if not found
        }
        
        console.log('ForeignCompanyDetails - viewArticleWithContext:', {
            articleId: articleToView?.id,
            articlesListLength: list.length,
            actualIndex
        });
        
        dispatch({
            type: ARTICLE,
            article: articleToView,
            articlesList: list,
            currentArticleIndex: actualIndex
        });
    };
    
    const getCompanyDetails = async (isInitialLoad = false) => {
        const id = props.match.params.id;
        if (isInitialLoad) {
            setCompanyLoading(true);
            setCompany(null);
            setExternalArticles([]);
        }
        try {
            const { data } = await callAPI(`/company/${id}/profile`, {}, 'GET');
            if (data?.profile) {
                if (data.profile.articleCount > 0) {
                    setSlideNo(1);
                }
                setCompany(data.profile);
                setCompanyBranch(data.profile.branch?.split(','));
                setServices(data.profile.services || []);
            } else if (isInitialLoad) {
                setCompany(null);
            }
        } catch (err) {
            if (isInitialLoad) setCompany(null);
        } finally {
            if (isInitialLoad) setCompanyLoading(false);
        }
    };

    const getExternalArticles = async () => {
        const id = props.match.params?.id;
        if (!id) return;
        setArticlesLoading(true);
        try {
            const { data } = await callAPI(`/company/${id}/getCompanyArticle`, {
                articleType: "0",
                lang: articleContentLang,
            }, "GET");
            const articles = data?.articles || [];
            const articlesWithLikes = articles.map(article => {
                if (!article.likes || !Array.isArray(article.likes)) {
                    article.likes = [];
                }
                return article;
            });
            setExternalArticles(articlesWithLikes);
        } catch (err) {
            setExternalArticles([]);
        } finally {
            setArticlesLoading(false);
        }
    };

    useEffect(() => {
        const id = props.match.params.id;
        if (!id) {
            setCompanyLoading(false);
            setArticlesLoading(false);
            return;
        }
        setArticlesLoading(true);
        getCompanyDetails(true).then(() => {
            getExternalArticles();
        });
    }, [props.match.params.id, articleContentLang])

    const expandArticle = async key => {
        console.log(key)
        const articles = externalArticles
        let article = articles[key];
        article.expand = true
        articles[key] = article;
        setExternalArticles([...articles])
    }

    const positions = Positions

    const handleSubmit = async () => {
        console.log(employeePosition)
        if (!employeePosition) {
            await $crud.notify({
                type: 'error',
                message: strings.please_select_position
            })
        } else {
            const params = {
                name: company.name,
                email: company.email,
                corporateForm: company.corporateForm,
                branch: company.branch,
                street: company.street,
                postCode: company.postCode,
                city: company.city,
                country: company.country,
                lat: company.lat,
                long: company.long,
                position: employeePosition
            }
            const { data } = await callAPI('/company', params, 'POST')
            setPositionDialog(false)
            await $crud.notify({
                type: data.status ? 'success' : 'error',
                message: data.message
            })
        }
    }
    const approveService = async (value) => {
        const { data } = await callAPI(`/service/${value}/join`, {
            id: value
        }, 'GET')
        $crud.notify({
            type: data.status ? 'success' : 'error',
            message: data.message
        })
        getCompanyDetails();
    };
    const CustomRightArrow = () => {
        CarouselEl.current.next()
        if (externalArticles.length > slideNo) {
            setSlideNo(slideNo + 1)
        }
    };

    const CustomLeftArrow = () => {
        CarouselEl.current.previous()
        if (slideNo !== 1) {
            setSlideNo(slideNo - 1)
        }
    };
    const handleLike = async (id) => {
        const articleDetails = externalArticles.find(article => article.id === id);
        if (!articleDetails) return;
        const articlesList = externalArticles.map(article => {
            if (article.id !== articleDetails.id) return article;
            const likes = Array.isArray(article.likes) ? [...article.likes] : [];
            const existUser = likes.find(like => like.id === user?.id);
            let newLikes, newCount, newLikeStatus;
            if (existUser) {
                // User already liked -> remove like
                newLikes = likes.filter(like => like.id !== user?.id);
                newCount = Math.max(0, (articleDetails.likeCount || 0) - 1);
                newLikeStatus = false;
            } else {
                // User hasn't liked -> add like
                newLikes = [{ id: user?.id, avatar: user?.avatar, userFullName: user?.fullName || user?.name }, ...likes];
                newCount = (articleDetails.likeCount || 0) + 1;
                newLikeStatus = true;
            }
            return { ...article, likeStatus: newLikeStatus, likes: newLikes, likeCount: newCount };
        });
        setExternalArticles(articlesList);
    }
    const dispatch = useDispatch()
    return (
        <React.Fragment>
            {/* Company loading skeleton */}
            {companyLoading && (
                <div className="company_section pb-0 p-0 foreign-company-details-page foreign-company-details__page">
                    <div className="foreign-company-details-content foreign-company-details__content">
                        <div className="bg-purple foreign-company-details__sk-header">
                            <div className="d-flex align-items-center justify-content-between foreign-company-details__top foreign-company-details__top--skeleton">
                                <div className="d-flex align-items-center foreign-company-details__actions">
                                    <Skeleton variant="rect" width={24} height={24} className="foreign-company-details__sk-icon" />
                                    <Skeleton variant="circle" width={40} height={40} />
                                    <Skeleton variant="rect" width={24} height={24} className="foreign-company-details__sk-icon" />
                                    <Skeleton variant="rect" width={24} height={24} className="foreign-company-details__sk-icon" />
                                </div>
                                <div className="d-flex foreign-company-details__sk-stats">
                                    <Skeleton variant="text" width={48} />
                                    <Skeleton variant="text" width={48} />
                                </div>
                            </div>
                            <div className="foreign-company-details__sk-name">
                                <Skeleton variant="text" width="60%" height={28} />
                                <Skeleton variant="text" width="80%" className="foreign-company-details__sk-mt8" />
                                <Skeleton variant="text" width="70%" className="foreign-company-details__sk-mt4" />
                            </div>
                        </div>
                        <div className="profile-data foreign-company-details__sk-data">
                            <Skeleton variant="text" width={80} height={24} className="foreign-company-details__sk-mb12" />
                            <Skeleton variant="rect" height={200} className="foreign-company-details__sk-card" />
                            <Skeleton variant="text" width={100} height={20} className="foreign-company-details__sk-mb8" />
                            <Skeleton variant="rect" height={60} className="foreign-company-details__sk-rounded" />
                        </div>
                    </div>
                </div>
            )}
            {
                !companyLoading && company &&
                <div className="company_section pb-0 p-0 foreign-company-details-page foreign-company-details__page">
                    <div className="foreign-company-details-content foreign-company-details__content">
                        <div className="bg-purple">
                            <div className="d-flex align-items-center justify-content-between foreign-company-details__top">
                                {/* Left side: Back arrow, Avatar and Action buttons */}
                                <div className="d-flex align-items-center foreign-company-details__actions">
                                    {/* Back button */}
                                    <span
                                        className={`material-symbols-outlined pointer foreign-company-details__back${backBtnHovered ? ' foreign-company-details__back--hover' : ''}${company.isKjuup ? ' foreign-company-details__back--internal' : ''}`}
                                        onClick={() => props.history.goBack()}
                                        onMouseEnter={() => setBackBtnHovered(true)}
                                        onMouseLeave={() => setBackBtnHovered(false)}
                                    >
                                        keyboard_arrow_left
                                    </span>
                                    <div className="user_profile">
                                        <div className="user_img">
                                            {company.logo ? (
                                                <img 
                                                    className="company_img foreign-company-details__logo"
                                                    width={40}
                                                    height={40}
                                                    src={BASE_URL + company.logo}
                                                    alt="Generic placeholder" />
                                            ) : (
                                                <div className="company_img_placeholder" aria-hidden="true">
                                                    <span className="material-symbols-outlined">image</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    {/* Add to company button */}
                                    <a
                                        onClick={e => {
                                            setPositionDialog(true)
                                            setEmployeePosition('Employee')
                                        }}
                                        className="pointer foreign-company-details__add-link"
                                    >
                                        <span
                                            className={`material-symbols-outlined foreign-company-details__add-icon${company.isKjuup ? ' foreign-company-details__add-icon--internal' : ''}`}
                                        >
                                            add_circle
                                        </span>
                                    </a>
                                </div>
                                {/* Right side: Stats */}
                                <div className={company.isKjuup ? 'follow-internal d-flex flex-column align-items-center text-center justify-content-center' : 'follow d-flex flex-column align-items-center text-center justify-content-center'}>
                                    <div className={`${company.isKjuup ? "follow_item_internal text-center" : "follow_item text-center"} foreign-company-details__stat-item`}>
                                        <h3 className={company.isKjuup ? "header-color-internal" : "header-color-base"}>{externalArticles?.length || 0}</h3>
                                        <p>{strings.article}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="profile-flied">
                                <div className="profile_name">
                                    <h3>{company?.companyName}</h3>
                                    {company.owner ?
                                        <p>{strings.owner_company_admin_new} :<span className={`foreign-company-details__owner${company.isKjuup ? ' foreign-company-details__owner--internal' : ''}`}> {company.owner}</span>
                                        </p> : ''}
                                    <p>{company.full_address ? company.full_address : `${company.houseNo ? company.houseNo + "," : ""} ${company.street}, ${company.city}, ${company.postCode ? company.postCode + "," : ""} ${company.country ? company.country : ''}`}</p>
                                    <p>{companyBranch?.map((itm, index) => (index ? ", " : "") + convertBranchRole(itm, isGerm))}</p>
                                    {company.position ?
                                        <p>{strings.my_position} {convertPosition(isGerm, company.position)}</p> : <></>}
                                </div>
                            </div>
                        </div>

                        <div className="profile-data">
                                {articlesLoading ? (
                                    <>
                                        <Skeleton variant="text" width={80} height={24} className="foreign-company-details__sk-mb12" />
                                        <Skeleton variant="rect" height={280} className="foreign-company-details__sk-card" />
                                        <Skeleton variant="text" width={100} height={20} className="foreign-company-details__sk-mb8" />
                                        <Skeleton variant="rect" height={80} className="foreign-company-details__sk-rounded" />
                                    </>
                                ) : (
                                <>
                                {externalArticles.length > 0 && (
                                <div className="article padding-left-right-2">
                                    {externalArticles.length > 0 &&
                                        <div className="profile-flied">
                                            <div className="profile_name">
                                                <h5>{strings.article}</h5>
                                            </div>
                                            <div className="icon_right">
                                                {
                                                    (company.role === 'ROLE_COMPANY_SUPER_ADMIN') ?
                                                        <Link to={`/add-company-article/${company.id}`}>
                                                            <img
                                                                src={process.env.PUBLIC_URL + "/assets/img/create-article.svg"} />
                                                        </Link> : ''
                                                }
                                            </div>
                                        </div>
                                    }
                                    {externalArticles.length > 0 && (
                                        <div className="slider-icon">
                                            <a 
                                                href="#" 
                                                onClick={e => { 
                                                    e.preventDefault(); 
                                                    if (slideNo > 1) {
                                                        CustomLeftArrow();
                                                    }
                                                }}
                                                className={`foreign-company-details__nav${slideNo > 1 ? '' : ' foreign-company-details__nav--disabled'}`}
                                            >
                                                <span
                                                    className={`material-symbols-outlined foreign-company-details__arrow${slideNo > 1 ? ' foreign-company-details__arrow--active' : ''}${company.isKjuup ? ' foreign-company-details__arrow--internal' : ''}`}
                                                >
                                                    keyboard_arrow_left
                                                </span>
                                            </a>
                                            <p>{slideNo} of {externalArticles.length} {strings.article}</p>
                                            <a href="#" onClick={e => { e.preventDefault(); CustomRightArrow(); }}>
                                                <span
                                                    className={`material-symbols-outlined foreign-company-details__arrow${externalArticles.length > slideNo ? ' foreign-company-details__arrow--active' : ''}${company.isKjuup ? ' foreign-company-details__arrow--internal' : ''}`}
                                                >
                                                    keyboard_arrow_right
                                                </span>
                                            </a>
                                        </div>
                                    )}
                                </div>
                                )}
                                {
                                    externalArticles.length > 0 ?
                                        <Carousel
                                            ref={CarouselEl}
                                            additionalTransfrom={0}
                                            arrows={false}
                                            centerMode={false}
                                            className="p-0"
                                            dotListClass=""
                                            draggable={externalArticles.length > 1}
                                            focusOnSelect={false}
                                            infinite={false}
                                            itemClass=""
                                            keyBoardControl
                                            minimumTouchDrag={80}
                                            renderButtonGroupOutside={false}
                                            renderDotsOutside={false}
                                            responsive={{
                                                desktop: {
                                                    breakpoint: {
                                                        max: 3000,
                                                        min: 1024
                                                    },
                                                    items: 1,
                                                },
                                                mobile: {
                                                    breakpoint: {
                                                        max: 464,
                                                        min: 0
                                                    },
                                                    items: 1
                                                },
                                                tablet: {
                                                    breakpoint: {
                                                        max: 1024,
                                                        min: 464
                                                    },
                                                    items: 1
                                                }
                                            }}
                                            sliderClass=""
                                            slidesToSlide={1}
                                            swipeable
                                        >
                                            {
                                                externalArticles.map((articleItem, key) => (
                                                    <div key={`external-${key}`} className="media-desc foreign-company-details__slide">
                                                        {
                                                            <ForienArticle
                                                                handleLike={handleLike}
                                                                viewArticleDetail={(art) => viewArticleWithContext(art, key)} 
                                                                company={company}
                                                                reloadArticle={() => getExternalArticles()}
                                                                index={key}
                                                                article={articleItem}
                                                                expandArticle={expandArticle}
                                                                hideLikeFollow
                                                            />
                                                        }
                                                    </div>
                                                ))
                                            }
                                        </Carousel> : ''
                                }
                                <div className={`foreign-company-contact-section${company?.isKjuup ? ' contact-internal' : ''}`}>
                                    <h5>{strings.contact}</h5>
                                    <div className="foreign-company-contact-items">
                                        {company?.website && (
                                            <div className="foreign-company-contact-item">
                                                <span className="material-symbols-outlined">language</span>
                                                <div>
                                                    <p>{strings.website}</p>
                                                    <a
                                                        href={company.website.startsWith('http') ? company.website : `https://${company.website}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {company.website}
                                                    </a>
                                                </div>
                                            </div>
                                        )}
                                        {company?.email && (
                                            <div className="foreign-company-contact-item">
                                                <span className="material-symbols-outlined">mail</span>
                                                <div>
                                                    <p>{strings.email}</p>
                                                    <a href={`mailto:${company.email}`}>
                                                        {company.email}
                                                    </a>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                </>
                                )}
                            </div>
                    </div>
                    <ShareMapDialog company={company} show={show} handleClose={handleClose} />
                </div>
            }
            {
                !companyLoading && !company &&
                <div className="company_section foreign-company-details__not-found">
                    <div className="bg-purple">
                        <div className="row">
                            <div className="col-md-5 pr-0">
                                <div className="user_profile">
                                    <div className="user_img">
                                        <Link to="/profile">
                                            <img className="img-fluid"
                                                src={process.env.PUBLIC_URL + "/assets/img/arrow_left-selected.svg"}
                                                alt="Generic placeholder" />
                                        </Link>
                                        <div className="company_img_placeholder" aria-hidden="true">
                                            <span className="material-symbols-outlined">image</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="p-2 pt-3 text-center">
                        {strings.record_not_found}
                    </div>
                </div>
            }
            <Modal show={showPositionDialog} onHide={hidePositionDialog} animation={false} centered size="md">
                <Modal.Header className="foreign-company-details__modal-header">
                    <Modal.Title className="foreign-company-details__modal-title">
                        {strings.your_position_within_company}
                    </Modal.Title>
                    <a 
                        onClick={hidePositionDialog} 
                        onMouseEnter={() => setCloseHover(true)}
                        onMouseLeave={() => setCloseHover(false)}
                        className="pointer foreign-company-details__modal-close"
                    >
                        <span
                            className={`material-symbols-outlined foreign-company-details__close-icon${closeHover ? ' foreign-company-details__close-icon--hover' : ''}${company.isKjuup ? ' foreign-company-details__close-icon--internal' : ''}`}
                        >
                            close
                        </span>
                    </a>
                </Modal.Header>
                <Modal.Body>
                    <div className="foreign-company-details__positions">
                        {
                            positions.map(position => (
                                <div 
                                    key={position.id}
                                    onClick={e => setEmployeePosition(position.name_en)} 
                                    className="pointer foreign-company-details__position"
                                >
                                    <label className={`container_checkbox ${company.isKjuup ? 'checkbox-internal' : ''} foreign-company-details__radio`}>
                                        <input 
                                            type="radio" 
                                            name="positionRadios"
                                            checked={employeePosition === position.name_en}
                                            onChange={() => setEmployeePosition(position.name_en)}
                                        />
                                        <span className="checkmark" />
                                    </label>
                                    <span className="foreign-company-details__position-label">
                                        {isGerm ? position.name_de : position.name_en}
                                    </span>
                                </div>
                            ))
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer className="foreign-company-details__modal-footer">
                    <button
                        type="button"
                        onClick={hidePositionDialog}
                        className={`kj-btn kj-btn--outline${company.isKjuup ? ' kj-btn--internal' : ''}`}
                    >
                        {strings.close_modal}
                    </button>
                    <button
                        type="button"
                        onClick={handleSubmit}
                        className={`kj-btn kj-btn--primary${company.isKjuup ? ' kj-btn--internal' : ''}`}
                    >
                        {strings.ok}
                    </button>
                </Modal.Footer>
            </Modal>
            {article && (
                <FeedViewDialog 
                    article={article} 
                    articlesList={articlesList || []}
                    currentArticleIndex={currentArticleIndex || 0}
                />
            )}
        </React.Fragment>
    );
}

export default withRouter(ForeignCompanyDetails);
